import React, { useState, Fragment, useEffect } from "react";
import axios from "axios";
import { Redirect } from "react-router-dom";
import crypto from "crypto";
import { osVersion, osName, browserName } from "react-device-detect";
import Button from "components/Button/Button.js";
import PasswordStrengthBar from "react-password-strength-bar";
import {
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Row,
  Col,
  Loader,
  Label,
} from "reactstrap";
import { truncate } from "fs";
import { routes, deleteRoutes } from "routes";
import IconTid from "../../assets/img/icons/Icono-Tipo-de-documento-Gris.png";
import IconPasw from "../../assets/img/icons/Icono-Contrasena-Gris.png";
import IconNid from "../../assets/img/icons/Icono-Numero-documento-Gris.png";
import IconCheck from "../../assets/img/icons/Check-01.png";
import Checksantader from "../siif/Checksantander.js";
import IconCorreo from "../../assets/img/icons/Icono-Correo-Gris.png";
import { Link } from "react-router-dom/cjs/react-router-dom";
import FotoSeg3 from "../../assets/img/brand/FotoSeg3.png";
import FotoSeg1 from "../../assets/img/brand/FotoSeg1.png";
import FotoSeg2 from "../../assets/img/brand/FotoSeg2.png";
import FotoSeg4 from "../../assets/img/brand/FotoSeg4.png";
import FotoSeg5 from "../../assets/img/brand/FotoSeg5.png";
import FotoSeg6 from "../../assets/img/brand/FotoSeg6.png";
import FotoSeg7 from "../../assets/img/brand/FotoSeg7.png";
import FotoSeg8 from "../../assets/img/brand/FotoSeg8.png";
import FotoSeg9 from "../../assets/img/brand/FotoSeg9.png";
import FotoSeg10 from "../../assets/img/brand/FotoSeg10.png";

const Cambio = () => {
  const search = window.location.search; // could be '?foo=bar'
  const params = new URLSearchParams(search);
  const trazabilityCode = params.get("trazabilityCode"); // bar

  console.log(trazabilityCode);

  const [imagenSeg, setImagenSeg] = useState();

  const getCookie = (name) => {
    let matches = document.cookie.match(
      new RegExp(
        "(?:^|; )" +
          name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
          "=([^;]*)"
      )
    );
    return matches ? decodeURIComponent(matches[1]) : undefined;
  };

  const [checkSelec, setcheckSelec] = useState(IconCheck);
  const [cambioEtapa, setCambioEtapa] = useState(false);
  const [fraseSeguridad, setFraseSeguridad] = useState("");

  //Loading
  const [isLoading, setIsloading] = useState(false);

  // alerts
  const [listAlert, setListAlert] = useState([]);
  const [coordenadas, setcoordenadas] = useState({
    Latitud: 0,
    Longitud: 0,
  });

  let nidAux = getCookie("nid");
  let hasNidAux = false;
  if (nidAux != undefined) {
    hasNidAux = true;
  }

  //login
  let estado = {
    tid: getCookie("tid") === undefined ? 3 : parseInt(getCookie("tid")),
    nid: nidAux,
    email: "",
    password: "",
  };

  const [hasNid, setHasNid] = useState(hasNidAux);
  const [hasPassword, setHasPassword] = useState(false);
  const [hasOTP, setHasOTP] = useState(false);
  const [hasNewPassword, setHasNewPassword] = useState(false);

  const [inicio, setinicio] = useState(false);
  const [tidnidpass, settidnidpass] = useState(estado);
  const [otptime, setotptime] = useState(false);

  let indicadores = {
    indicatorChangePass: false,
    indicatorOTP: false,
    indicatorQuestions: false,
    idUnico: "",
    idContrato: "",
  };

  const [indi, setIndi] = useState(indicadores);

  const [isRemember, setIsRemember] = useState(false);

  const obtieneUbicacion = async () => {
    let coord = {
      Latitud: 0,
      Longitud: 0,
    };

    if ("geolocation" in navigator) {
      const onUbicacionConcedida = (ubicacion) => {
        setcoordenadas({ ...coordenadas, Latitud: ubicacion.coords.latitude });
        setcoordenadas({
          ...coordenadas,
          Longitud: ubicacion.coords.longitude,
        });
        //console.log("Tengo la ubicación: ", ubicacion.coords);
        return coord;
      };

      const onErrorDeUbicacion = (err) => {
        //console.log("Error obteniendo ubicación: ", err);
        return coord;
      };

      const opcionesDeSolicitud = {
        enableHighAccuracy: true, // Alta precisión
        maximumAge: 0, // No queremos caché
        timeout: 8000, // Esperar solo 5 segundos
      };
      // Solicitar
      await navigator.geolocation.getCurrentPosition(
        onUbicacionConcedida,
        onErrorDeUbicacion,
        opcionesDeSolicitud
      );
    }
  };

  const handleChangeTID = (event) => {
    settidnidpass({ ...tidnidpass, tid: event.target.value });
    console.log(tidnidpass);
  };

  const handleChangeID = (event) => {
    settidnidpass({ ...tidnidpass, nid: event.target.value });
    setHasNid(event.target.value.trim() != "");
  };

  const handleChangeEmail = (event) => {
    settidnidpass({ ...tidnidpass, email: event.target.value });
  };

  const handleChangePassword = (event) => {
    settidnidpass({ ...tidnidpass, password: event.target.value });
    setHasPassword(event.target.value.trim() != "");
  };

  const handleChangeIsRemember = (event) => {
    setIsRemember(!isRemember);
  };

  useEffect(async () => {
    const timer = setTimeout(deleteElementFromArr, 5000);
    return () => clearTimeout(timer);
  });

  const deleteElementFromArr = () => {
    if (listAlert.length > 0) {
      let temp = listAlert.slice();
      temp.splice(0, 1);
      setListAlert(temp);
    }
  };

  const deleteAlert = (alert) => {
    setListAlert(listAlert.filter((auxAlert) => auxAlert != alert));
  };

  var createReactClass = require("create-react-class");
  var Alerts = createReactClass({
    render: function () {
      var data = this.props.data;
      var newsTemplate;
      if (data.length > 0) {
        newsTemplate = data.map(function (item, index) {
          return (
            <div class={item.type} role="alert">
              <button
                type="button"
                class="close"
                aria-label="Close"
                onClick={() => deleteAlert(item)}
              >
                <span aria-hidden="true">×</span>
              </button>
              <span className="alert-inner--icon mr-3">
                <i className={item.icon} />
              </span>{" "}
              <span class="alert-inner--text">{item.description}</span>
            </div>
          );
        });
      }
      return <div className="toast-bottom-right">{newsTemplate}</div>;
    },
  });

  const randomString = (str) => {
    var text = "";

    for (var i = 0; i < str.length; i++)
      text += str.charAt(Math.floor(Math.random() * str.length));

    return text;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    setIsloading(true);
    await obtieneUbicacion();

    const apiUrlIp = "https://api.ipify.org/?format=json";
    const resIp = await axios.get(apiUrlIp).catch((err) => {});

    let cdi = getCookie("CDIi");

    let passHashed = crypto
      .createHash("sha1")
      .update(tidnidpass.password)
      .digest("hex")
      .toUpperCase();
    console.log("contraseña encriptada :" + passHashed);
    console.log(coordenadas);
    let Ip1 = "";
    try {
      Ip1 = resIp.data.ip;
    } catch (error) {}
    const user = {
      IDTypeCompany: parseInt(tidnidpass.tid),
      NIDCompany: tidnidpass.nid,
      email: tidnidpass.email.toLowerCase(),
      LoginPassword: passHashed,
      RegisterPassword: cdi,
      DeviceName: osName,
      DeviceSerial: "",
      DeviceBrand: osVersion,
      Model: browserName,
      SO: osVersion,
      Longitude: coordenadas.Longitud.toString(),
      Latitud: coordenadas.Latitud.toString(),
      Version: "0.1.0.2",
      IP: Ip1,
      idDeviceFireBase: "string",
      isRemember: isRemember,
    };
    console.log(user);

    const apiUrl = "/WSGYG39_2/api/Users/SignIn";
    console.log(tidnidpass);
    const res = await axios
      .post(apiUrl, user, { withCredentials: true })
      .catch((err) => {
        setIsloading(false);
        console.log("err.response.data.errors");
        console.log(err.response.data.errors);
        try {
          if (err.response.data.errors) {
            setListAlert(
              err.response.data.errors.map((o) => ({
                ...o,
                type: "alert alert-alert show alert-dismissible fade alert-danger",
                icon: "fas fa-exclamation-circle",
              }))
            );
          } else {
            setListAlert([
              {
                description: "Error.",
                type: "alert alert-alert show alert-dismissible fade alert-danger",
                icon: "fas fa-exclamation-circle",
              },
            ]);
          }
        } catch (error) {
          setListAlert([
            {
              description: "Por favor validar la información ingresada.",
              type: "alert alert-alert show alert-dismissible fade alert-danger",
              icon: "fas fa-exclamation-circle",
            },
          ]);
        }
        return "err";
      });
    /*.catch(err => {
            console.log(osName);
            setListAlert([{messagge: "Error al logearse", type: "danger", icon: "fas fa-exclamation-circle"}]);
            //return 'err';
        });
        console.log(res.errors);*/

    if (res != "err") {
      setIsloading(false);
      setIndi({
        indicatorChangePass: res.data.indicatorChangePass,
        indicatorOTP: res.data.indicatorOTP,
        indicatorQuestions: res.data.indicatorQuestions,
        idUnico: res.data.idUnico,
        idContrato: res.data.idContrato,
      });
      switch (res.data.idImage) {
        case 1:
          setImagenSeg(FotoSeg1);
          break;
        case 2:
          setImagenSeg(FotoSeg2);
          break;
        case 3:
          setImagenSeg(FotoSeg3);
          break;
        case 4:
          setImagenSeg(FotoSeg4);
          break;
        case 5:
          setImagenSeg(FotoSeg5);
          break;
        case 6:
          setImagenSeg(FotoSeg6);
          break;
        case 7:
          setImagenSeg(FotoSeg7);
          break;
        case 8:
          setImagenSeg(FotoSeg8);
          break;
        case 9:
          setImagenSeg(FotoSeg9);
          break;
        case 10:
          setImagenSeg(FotoSeg10);
          break;
        default:
          break;
      }

      setFraseSeguridad(res.data.securityText);
      if (
        res.data.indicatorChangePass === false &&
        res.data.indicatorOTP === false &&
        res.data.indicatorQuestions === false
      ) {
        var d = new Date();
        d.setTime(d.getTime() + 5000 * 60 * 1000);
        var expires = "expires=" + d.toUTCString();
        document.cookie =
          "tid" + "=" + tidnidpass.tid + "; " + expires + "; path=/";
        document.cookie =
          "nid" + "=" + tidnidpass.nid + "; " + expires + "; path=/";
        //Cookie for email
        document.cookie =
        "email" + "=" + tidnidpass.email + "; " + expires + "; path=/";
        document.cookie =
          "dateLastLog" +
          "=" +
          res.data.dateLastLog +
          "; " +
          expires +
          "; path=/";
        document.cookie =
          "ipLastLog" + "=" + res.data.ipLastLog + "; " + expires + "; path=/";
        document.cookie =
          "profile" + "=" + res.data.ipLastLog + "; " + expires + "; path=/";
        window.location = "/BancaVirtual/admin/home";
      }
    }
  };
  //fin de login

  const loginOtp = async () => {
    //loguin posterior a otp
    //setIsloading(true);
    const apiUrlIp = "https://api.ipify.org/?format=json";
    const resIp = await axios.get(apiUrlIp).catch((err) => {});

    let cdi = getCookie("CDI");

    let passHashed = crypto
      .createHash("sha1")
      .update(tidnidpass.password)
      .digest("hex")
      .toUpperCase();
    console.log("contraseña encriptada :" + passHashed);
    let Ip1 = "";
    try {
      Ip1 = resIp.data.ip;
    } catch (error) {}
    const user = {
      IDTypeCompany: parseInt(tidnidpass.tid),
      NIDCompany: tidnidpass.nid,
      email: tidnidpass.email.toLowerCase(),
      LoginPassword: passHashed,
      RegisterPassword: cdi,
      DeviceName: osName,
      DeviceSerial: "",
      DeviceBrand: osVersion,
      Model: browserName,
      SO: osVersion,
      Longitude: coordenadas.Longitud.toString(),
      Latitud: coordenadas.Latitud.toString(),
      Version: "0.1.0.2",
      IP: Ip1,
      idDeviceFireBase: "string",
      isRemember: isRemember,
    };
    console.log(user);

    const apiUrl = "/WSGYG39_2/api/Users/SignIn";
    console.log(tidnidpass);
    const res = await axios
      .post(apiUrl, user, { withCredentials: true })
      .catch((err) => {
        setIsloading(false);
        if (err.response.data.errors) {
          setListAlert(
            err.response.data.errors.map((o) => ({
              ...o,
              type: "alert alert-alert show alert-dismissible fade alert-danger",
              icon: "fas fa-exclamation-circle",
            }))
          );
        } else {
          setListAlert([
            {
              description: "Error.",
              type: "alert alert-alert show alert-dismissible fade alert-danger",
              icon: "fas fa-exclamation-circle",
            },
          ]);
        }
        return "err";
      });
    /*.catch(err => {
            console.log(osName);
            setListAlert([{messagge: "Error al logearse", type: "danger", icon: "fas fa-exclamation-circle"}]);
            //return 'err';
        });
        console.log(res.errors);*/

    if (res != "err") {
      setotptime(true);
      setIndi({
        indicatorChangePass: res.data.indicatorChangePass,
        indicatorOTP: res.data.indicatorOTP,
        indicatorQuestions: res.data.indicatorQuestions,
        idUnico: res.data.idUnico,
        idContrato: res.data.idContrato,
      });
      if (
        res.data.indicatorChangePass === false &&
        res.data.indicatorOTP === false &&
        res.data.indicatorQuestions === false
      ) {
        var d = new Date();
        d.setTime(d.getTime() + 5000 * 60 * 1000);
        var expires = "expires=" + d.toUTCString();
        document.cookie =
          "tid" + "=" + tidnidpass.tid + "; " + expires + "; path=/";
        document.cookie =
          "nid" + "=" + tidnidpass.nid + "; " + expires + "; path=/";
        //Cookie for email
        document.cookie =
        "email" + "=" + tidnidpass.email + "; " + expires + "; path=/";
        document.cookie =
          "dateLastLog" +
          "=" +
          res.data.dateLastLog +
          "; " +
          expires +
          "; path=/";
        document.cookie =
          "ipLastLog" + "=" + res.data.ipLastLog + "; " + expires + "; path=/";
        document.cookie =
          "profile" + "=" + res.data.ipLastLog + "; " + expires + "; path=/";
        window.location = "/BancaVirtual/admin/home";
      } else {
        setotptime(false);
      }

      setIsloading(false);
    }
  };

  //cambio de contraseña
  const [newContra, setnewContra] = useState("");
  const [validContra, setvalidContra] = useState(false);
  const [mensaje, setmensaje] = useState(() => {
    return (
      <div>
        <h1
          style={{
            fontSize: "32px",
            textAlign: "left",
            "font-weight": "bold",
            "line-height": 1 + "em",
          }}
          className="h1santander"
        >
          Tu clave ha caducado.
        </h1>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "left",
            alignItems: "flex-start",
          }}
        >
          <p style={{ margin: "0px 0px 0px 0px", textAlign: "left" }}>
            Digita una nueva contraseña por favor.
          </p>
          <p style={{ margin: "0px 0px 0px 0px", textAlign: "left" }}>
            <ul class="mb-0" style={{ "padding-inline-start": "20px" }}>
              <li>Longitud Mínima 12.</li>
              <li>Debe contener mayúsculas y minúsculas.</li>
              <li>Caracteres especial y números.</li>
              <li>Tiene una vigencia de 120 días.</li>
            </ul>
          </p>
        </div>
      </div>
    );
  });
  const [contraProv, setcontraProv] = useState("");

  const tipContra = (event) => {
    console.log(event.target.value);
    setcontraProv(event.target.value);
    setHasNewPassword(event.target.value.trim() != "");
  };

  const nuevaContraseña = async (event) => {
    event.preventDefault();
    if (validContra === false) {
      var re = new RegExp("/^([a-z0-9]{5,})$/");
      if (contraProv.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/)) {
        console.log(contraProv);
        console.log("Valid");
      } else {
        console.log("Invalid");
      }
      setHasNewPassword(false);
      setnewContra(contraProv);
      setvalidContra(true);
      setcontraProv("");
      setmensaje("Vuelve a digitar la nueva contraseña para confirmarla.");
    } else {
      if (newContra === contraProv) {
        //setinicio(true);
        setIsloading(true);
        let passHashed = crypto
          .createHash("sha1")
          .update(tidnidpass.password)
          .digest("hex")
          .toUpperCase();
        const user = {
          IdUnico: indi.idUnico,
          IdContrato: indi.idContrato,
          OldPassword: passHashed,
          NewPassword: newContra,
          NewPasswordC: contraProv,
          RegisterPassword: "",
          Longitude: "-122.40641",
          Latitude: "37.785834",
        };
        const apiUrl = "/WSGYG39_2/api/ChangePasswords";
        const res = await axios
          .post(apiUrl, user, { withCredentials: true })
          .catch((err) => {
            setIsloading(false);
            console.log(err.response);

            setHasNewPassword(false);
            if (err.response.data.errors) {
              setListAlert(
                err.response.data.errors.map((o) => ({
                  ...o,
                  type: "alert alert-alert show alert-dismissible fade alert-danger",
                  icon: "fas fa-exclamation-circle",
                }))
              );
            } else {
              setListAlert([
                {
                  description: "Error Cambiando contraseña intente nuevamente.",
                  type: "alert alert-alert show alert-dismissible fade alert-danger",
                  icon: "fas fa-exclamation-circle",
                },
              ]);
            }
            /*setListAlert([
              {
                description: "Error en la peticion cambio de clave",
                type: "alert alert-alert show alert-dismissible fade alert-danger",
                icon: "fas fa-exclamation-circle",
              },
            ]);*/
            setIndi({
              indicatorChangePass: false,
              indicatorOTP: false,
              indicatorQuestions: false,
            });
            setnewContra("");
            setcontraProv("");
            setvalidContra(false);
            setmensaje(() => {
              return (
                <div>
                  <h1
                    style={{
                      fontSize: "32px",
                      textAlign: "left",
                      "font-weight": "bold",
                    }}
                    className="h1santander"
                  >
                    Tu clave ha caducado.
                  </h1>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "left",
                      alignItems: "flex-start",
                    }}
                  >
                    <p style={{ margin: "0px 0px 0px 5px", textAlign: "left" }}>
                      Digita una nueva contraseña por favor.
                    </p>
                    <p style={{ margin: "0px 0px 0px 5px" }}>
                      - Longitud Mínima 12.{" "}
                    </p>
                    <p style={{ margin: "0px 0px 0px 5px" }}>
                      - Debe contener mayúsculas y minúsculas.
                    </p>
                    <p style={{ margin: "0px 0px 0px 5px" }}>
                      - Caracteres especial y números.
                    </p>
                    <p style={{ margin: "0px 0px 0px 5px" }}>
                      - Tiene una vigencia de 120 días.
                    </p>
                  </div>
                </div>
              );
            });
            return "err";
          });
        if (res != "err") {
          setIsloading(false);
          setHasNewPassword(false);
          setListAlert([
            {
              description: "La clave fue cambiada correctamente",
              type: "alert alert-alert show alert-dismissible fade alert-success",
              icon: "fas fa-check-circle",
            },
          ]);
          setIndi({
            indicatorChangePass: false,
            indicatorOTP: false,
            indicatorQuestions: false,
          });
          setmensaje(() => {
            return (
              <div>
                <h1
                  style={{
                    fontSize: "32px",
                    textAlign: "left",
                    "font-weight": "bold",
                  }}
                  className="h1santander"
                >
                  Tu clave ha caducado.
                </h1>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "left",
                    alignItems: "flex-start",
                  }}
                >
                  <p style={{ margin: "0px 0px 0px 5px", textAlign: "left" }}>
                    Digita una nueva contraseña por favor.
                  </p>
                  <p style={{ margin: "0px 0px 0px 5px" }}>
                    - Longitud Mínima 12.{" "}
                  </p>
                  <p style={{ margin: "0px 0px 0px 5px" }}>
                    - Debe contener mayúsculas y minúsculas.
                  </p>
                  <p style={{ margin: "0px 0px 0px 5px" }}>
                    - Caracteres especial y números.
                  </p>
                  <p style={{ margin: "0px 0px 0px 5px" }}>
                    - Tiene una vigencia de 120 días.
                  </p>
                </div>
              </div>
            );
          });
          setnewContra("");
          setcontraProv("");
          setvalidContra(false);
        }
      } else {
        setIsloading(false);
        setvalidContra(false);
        setHasNewPassword(false);
        setmensaje(
          "La confirmacion de la contraseña fue incorrecta.Vuelve a digitar la nueva contraseña"
        );
        setnewContra("");
        setcontraProv("");
        setcontraProv("");
      }
    }
  };

  //fin de cambio de contraseña

  //validacion OTP

  const [codOtp, setcodOtp] = useState("");

  const digitaOtp = (event) => {
    setcodOtp(event.target.value);
    setHasOTP(event.target.value.trim() != "");
  };

  const validaOTP = async (event) => {
    event.preventDefault();
    setIsloading(true);
    const apiUrlIp = "https://api.ipify.org/?format=json";
    const resIp = await axios.get(apiUrlIp).catch((err) => {});

    console.log("codigo otp " + codOtp);
    let Ip1 = "";
    try {
      Ip1 = resIp.data.ip;
    } catch (error) {}
    const user = {
      IdUnico: indi.idUnico,
      LoginPassword: codOtp,
      RegisterPassword: "",
      DeviceName: osName,
      DeviceSerial: "",
      DeviceBrand: osVersion,
      Model: browserName,
      SO: osVersion,
      Longitude: "-122.40641",
      Latitude: "37.785834",
      Version: "0.1.0.2",
      IP: Ip1,
      idDeviceFireBase: "string",
    };
    console.log(user.ClaveIngreso);

    const apiUrl = "/WSGYG39_2/api/Users/validOTP";
    const res = await axios
      .post(apiUrl, user, { withCredentials: true })
      .catch((err) => {
        setIsloading(false);

        if (err.response.data.errors) {
          setListAlert(
            err.response.data.errors.map((o) => ({
              ...o,
              type: "alert alert-alert show alert-dismissible fade alert-danger",
              icon: "fas fa-exclamation-circle",
            }))
          );
        } else {
          setListAlert([
            {
              description: "Error.",
              type: "alert alert-alert show alert-dismissible fade alert-danger",
              icon: "fas fa-exclamation-circle",
            },
          ]);
        }
        return "err";
      });
    if (res != "err") {
      //setIsloading(false);
      /*
      setIndi({
        indicatorChangePass: res.data.indicatorChangePass,
        indicatorOTP: res.data.indicatorOTP,
        indicatorQuestions: res.data.indicatorQuestions,
      });
      */
      setListAlert([
        {
          description: "Contraseña temporal correcta.",
          type: "alert alert-alert show alert-dismissible fade alert-success",
          icon: "fas fa-check-circle",
        },
      ]);

      loginOtp();
    }
  };

  //fin de validacion OTP
  const Botonlogin = (props) => {
    switch (props.indicador) {
      case 1:
        if (hasNid && hasPassword && !isLoading) {
          return (
            <>
              <Button
                style={{ width: "75%" }}
                isLoading={isLoading}
                disabled={!(hasNid && hasPassword && !isLoading)}
                className="my-title  my-1 mt-1 btn bg-green text-white btn-block ml-auto mr-auto"
                onClick={handleSubmit}
              >
                Acceder
              </Button>
              <div>
                ¿Requiere crear una cuenta?
                <br></br> Regístrese &nbsp;
                <Link to="/auth/AuxiliarRegistro" className="text-green">
                  Aquí
                </Link>
              </div>
              <div>
                <a href="../../bancasupervisor" className="text-green">
                  Soy Supervisor
                </a>
              </div>
            </>
          );
        } else {
          return (
            <>
              <Button
                isLoading={isLoading}
                className="my-title  my-1 mt-1 btn-block btn ml-auto mr-auto"
                style={{
                  border: "#767676 1px solid",
                  background: "#F6F6F6",
                  color: "#767676",
                  width: "75%",
                }}
              >
                Acceder
              </Button>
              <div>
                ¿Requiere crear una cuenta?
                <br></br> Regístrese &nbsp;
                <Link to="/auth/AuxiliarRegistro" className="text-green">
                  Aquí
                </Link>
              </div>
              <div>
                <a href="../../bancasupervisor" className="text-green">
                  Soy Supervisor
                </a>
              </div>
            </>
          );
        }
        break;
      case 2:
        if (hasOTP && !isLoading) {
          return (
            <Button
              style={{ width: "75%" }}
              isLoading={isLoading}
              disabled={!(hasOTP && !isLoading)}
              className=" my-1 mt-1 btn bg-green text-white btn-block ml-auto mr-auto"
              onClick={validaOTP}
            >
              Enviar
            </Button>
          );
        } else {
          return (
            <Button
              isLoading={isLoading}
              disabled={!(hasOTP && !isLoading)}
              className=" my-1 mt-1 btn btn-block ml-auto mr-auto"
              style={{
                border: "#767676 1px solid",
                background: "#F6F6F6",
                color: "#767676",
                width: "75%",
              }}
            >
              Enviar
            </Button>
          );
        }
        break;
      case 3:
        if (hasNewPassword && !isLoading) {
          return (
            <Button
              style={{ width: "75%" }}
              isLoading={isLoading}
              disabled={!(hasNewPassword && !isLoading)}
              className=" my-1 mt-1 btn bg-green text-white btn-block ml-auto mr-auto"
              onClick={nuevaContraseña}
            >
              Enviar
            </Button>
          );
        } else {
          return (
            <Button
              isLoading={isLoading}
              disabled={!(hasNewPassword && !isLoading)}
              className=" my-1 mt-1 btn btn-block ml-auto mr-auto"
              style={{
                border: "#767676 1px solid",
                background: "#f6f6f6",
                color: "#767676",
                width: "75%",
              }}
            >
              Enviar
            </Button>
          );
        }
        break;
      default:
        return (
          <>
            <Button
              isLoading={isLoading}
              className="my-title  my-1 mt-1 btn-block btn ml-auto mr-auto"
              style={{
                border: "#767676 1px solid",
                background: "#f6f6f6",
                color: "#767676",
                width: "75%",
              }}
            >
              Acceder
            </Button>
            <div>
              ¿Requiere crear una cuenta?
              <br></br> Resgístrese &nbsp;
              <Link to="/auth/AuxiliarRegistro" className="text-green">
                Aquí
              </Link>
            </div>
            <div>
              <a href="../../bancasupervisor" className="text-green">
                Soy Supervisor
              </a>
            </div>
          </>
        );
    }
  };

  if (
    indi.indicatorChangePass === false &&
    indi.indicatorOTP === false &&
    indi.indicatorQuestions === false &&
    inicio === false &&
    otptime == false
  ) {
    return (
      <Fragment>
        <div
          style={{
            width: "100%",
            zIndex: "10",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div style={{ width: "50%" }}>
            <h1
              className="h1santander"
              style={{
                fontSize: "32px",
                margin: "16px",
                "font-weight": "bold",
                "line-height": 1 + "em",
              }}
            >
              Sucursal Virtual IDEA
            </h1>
            <p style={{ margin: "16px", "line-height": 1.25 + "em" }}>
              Realice consultas, pagos y transferencias de su compañia en línea
              y de manera segura.
            </p>
            <div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "3px",
                  borderTop: "#DFE4E1 1px solid",
                  borderLeft: "#DFE4E1 1px solid",
                  borderRight: "#DFE4E1 1px solid",
                  borderBottom: "#767676 1px solid",
                  padding: "4px 8px 4px 4px",
                  borderRadius: "5px 5px 0px 0px",
                  margin: "15px",
                  "margin-top": "0px",
                }}
              >
                <select
                  onChange={handleChangeTID}
                  placeholder="Nit de la empresa"
                  style={{ border: "none", width: "100%", fontSize: "14px" }}
                >
                  <option value="1">Cédula de Ciudadanía</option>
                  <option value="2">Tarjeta de Identidad</option>
                  <option value="3" selected>
                    NIT
                  </option>
                  <option value="5">Pasaporte</option>
                  <option value="6">Carnet Diplomático</option>
                  <option value="8">Fideicomiso</option>
                  <option value="9">Registro Civil de Nacimiento</option>
                </select>
                <img style={{ height: "12px" }} src={IconTid}></img>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "3px",
                  borderTop: "#DFE4E1 1px solid",
                  borderLeft: "#DFE4E1 1px solid",
                  borderRight: "#DFE4E1 1px solid",
                  borderBottom: "#767676 1px solid",
                  padding: "4px 8px 4px 4px",
                  borderRadius: "5px 5px 0px 0px",
                  margin: "15px",
                }}
              >
                <input
                  onChange={handleChangeID}
                  value={tidnidpass.nid}
                  style={{
                    fontSize: "14px",
                    border: "none",
                    width: "250px",
                    height: "25px",
                    padding: "0px 0px 0px 5px",
                    margin: "0px 0px 0px 0px",
                  }}
                  placeholder="Nit de la Empresa (Sin DV)"
                />
                <img style={{ height: "12px" }} src={IconNid}></img>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "3px",
                  borderTop: "#DFE4E1 1px solid",
                  borderLeft: "#DFE4E1 1px solid",
                  borderRight: "#DFE4E1 1px solid",
                  borderBottom: "#767676 1px solid",
                  padding: "4px 8px 4px 4px",
                  borderRadius: "5px 5px 0px 0px",
                  margin: "15px",
                }}
              >
                <input
                  onChange={handleChangeEmail}
                  value={tidnidpass.email}
                  style={{
                    fontSize: "14px",
                    border: "none",
                    width: "250px",
                    height: "25px",
                    padding: "0px 0px 0px 5px",
                    margin: "0px 0px 0px 0px",
                  }}
                  placeholder="Correo de Usuario"
                />
                <img style={{ height: "12px" }} src={IconCorreo}></img>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "3px",
                  borderTop: "#DFE4E1 1px solid",
                  borderLeft: "#DFE4E1 1px solid",
                  borderRight: "#DFE4E1 1px solid",
                  borderBottom: "#767676 1px solid",
                  padding: "4px 8px 4px 4px",
                  borderRadius: "5px 5px 0px 0px",
                  margin: "15px",
                }}
              >
                <input
                  onChange={handleChangePassword}
                  style={{
                    fontSize: "14px",
                    border: "none",
                    width: "250px",
                    height: "25px",
                    padding: "0px 0px 0px 5px",
                    margin: "0px 0px 0px 0px",
                  }}
                  placeholder="Contraseña de Usuario"
                  type="password"
                />
                <img style={{ height: "16px" }} src={IconPasw}></img>
              </div>
              {/*</div>*/}
              {/*
              <div style={{margin:"20px",display:"flex",flexDirection:"row",justifyContent:"flex-start",alignItems:"flex-start", gap:"4px"}}>
                <img style={{height:"25px"}} src={checkSelec}></img>
                <p style={{display:"inline"}}>Recordar usuario</p>
              </div>
              */}
              <div style={{ padding: "2px 3px 2px 3px", margin: "5px" }}>
                <Checksantader
                  mensaje={"Recordar usuario"}
                  estadocheck={false}
                ></Checksantader>
              </div>
            </div>
            <div
              className="text-center"
              style={{ padding: "4px 4px 4px 4px", margin: "4px 8px 4px 8px" }}
            >
              <Botonlogin indicador={1}></Botonlogin>
            </div>
            <Alerts data={listAlert}></Alerts>
          </div>
        </div>

        {/* 
        <Col lg="10" md="7">
          <Card className="shadow border-0">
            <CardHeader className="bg-transparent">
              <div className="my-title text-center text/bold" style={{fontSize: '1.1em'}}>Ingresa los siguientes datos</div>
            </CardHeader>
            <CardBody className="px-lg-2 py-lg-2">
              <Form role="form">
                <FormGroup>
                  <InputGroup className="input-group-alternative">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="far fa-list-alt" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <select
                      onChange={handleChangeTID}
                      class="selectpicker"
                      placeholder="Tipo de Docuemnto"
                      className="form-control input-group-alternative"
                    >
                      <option value="1">Cedula de Ciudadania</option>
                      <option value="2">Tarjeta de Identidad</option>
                      <option value="3">NIT</option>
                    </select>
                  </InputGroup>
                </FormGroup>
                {/*<FormGroup>
                  <InputGroup className="input-group-alternative">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="fas fa-id-card" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="Número de Documento de Identidad"
                      autoComplete="new-nid"
                      onChange={handleChangeID}
                      value={tidnidpass.nid}
                    />
                  </InputGroup>
                </FormGroup>}
                <div className="input-group">

                    <input

                      placeholder="Número de documento"

                      autoComplete="new-nid"

                      onChange={handleChangeID}

                      value={tidnidpass.nid}

                    />

                    <img className="input-image" src={IconTid}></img>

                </div>
                <FormGroup>
                  <InputGroup className="input-group-alternative">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="fas fa-envelope" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="Correo"
                      type="text"
                      autoComplete="new-email"
                      onChange={handleChangeEmail}
                    />
                  </InputGroup>
                </FormGroup>
                <FormGroup>
                  <InputGroup className="input-group-alternative">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="fas fa-lock" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="Contraseña"
                      type="password"
                      autoComplete="new-password"
                      onChange={handleChangePassword}
                    />
                  </InputGroup>
                </FormGroup>
                <div className="custom-control custom-control-alternative custom-checkbox ml-5">
                  <input
                    className="custom-control-input"
                    id="customCheck5"
                    type="checkbox"
                    checked={isRemember}
                    onChange={() => handleChangeIsRemember()}
                  />
                  <label
                    className="custom-control-label"
                    htmlFor="customCheck5"
                  >
                    Recordarme
                  </label>
                </div>
                <div className="text-center">
                  <Button
                    isLoading={isLoading}
                    disabled={!(hasNid && hasPassword && !isLoading)}
                    className="my-title my-btn my-4 mt-5 btn bg-green text-white btn-block shadow"
                    onClick={handleSubmit}
                  >
                    Acceder
                  </Button>
                </div>
              </Form>
            </CardBody>
          </Card>
        </Col>
        <Alerts data={listAlert}></Alerts>
      */}
      </Fragment>
    );
  } else if (indi.indicatorOTP) {
    return (
      <Fragment>
        <div
          style={{
            width: "100%",
            zIndex: "10",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div style={{ width: "50%" }}>
            <Col>
              <Card className="border-0">
                <CardHeader
                  className="bg-transparent pb-2"
                  style={{ padding: "16px 16px 16px 16px", width: "350px" }}
                >
                  <div style={{ display: "flex" }}>
                    <h1
                      className="h1santander"
                      style={{
                        fontSize: "32px",
                        marginLeft: "0px",
                        marginBottom: "5px",
                        "font-weight": "bold",
                        "line-height": 1 + "em",
                      }}
                    >
                      Sucursal Virtual IDEA
                    </h1>
                    <div style={{ display: "flex", height: "50px" }}>
                      <img
                        className="ml-0 mt-3"
                        src={
                          require("../../assets/img/icons/Flecha Abajo-Verde-blanca.png")
                            .default
                        }
                      />
                      <a
                        role="button"
                        className="h6 mt-3 mb-0 ml-0 text-green "
                        href="auth/cambioCotraseña"
                      >
                        {"Regresar a inicio"}
                      </a>
                    </div>
                  </div>
                  <div
                    className="mt-4 text-black"
                    style={{ "line-height": 1.25 + "em" }}
                  >
                    Antes de iniciar sesión compruebe que <br /> la siguiente
                    información es correcta
                  </div>
                  <p className="mt-2" style={{ fontWeight: "bold" }}>
                    Imagen de seguridad
                  </p>
                  <img
                    className="ml-7"
                    id=""
                    style={{ height: "80px", width: "80px", cursor: "pointer" }}
                    src={imagenSeg}
                  />
                  <p className="mt-3" style={{ fontWeight: "bold" }}>
                    Frase de seguridad
                  </p>
                  <p>{fraseSeguridad}</p>
                  <div
                    className=" mt-2 text-black"
                    style={{ "line-height": 1.25 + "em" }}
                  >
                    Si los datos coinciden, introduzca la contraseña temporal
                    enviada a su correo electrónico registrado
                  </div>
                </CardHeader>
                <CardBody className="px-lg-3 py-lg-3">
                  <Form role="form">
                    <FormGroup className="mb-3 ml-4">
                      <InputGroup className="input-group-alternative">
                        <div className="inputs-icons-borderbott">
                          <Input
                            placeholder="Clave temporal"
                            autoComplete="new-email"
                            onChange={digitaOtp}
                            style={{
                              fontSize: "14px",
                              border: "none",
                              width: "250px",
                              height: "25px",
                              padding: "0px 0px 0px 5px",
                              margin: "0px 0px 0px 0px",
                            }}
                          />
                          <img style={{ height: "16px" }} src={IconPasw}></img>
                        </div>
                      </InputGroup>
                    </FormGroup>
                    <div className="text-center ml-4">
                      <Botonlogin indicador={2}></Botonlogin>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
            <Alerts data={listAlert}></Alerts>
          </div>
        </div>
      </Fragment>
    );
  } else if (indi.indicatorChangePass) {
    return (
      <Fragment>
        <div
          style={{
            width: "100%",
            zIndex: "10",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div style={{ width: "50%" }}>
            <Col>
              <Card className="border-0">
                <CardHeader
                  className="bg-transparent pb-1"
                  style={{ padding: "16px 16px 16px 16px" }}
                >
                  <div className="text-muted text-left mt-2 mb-1 text-black">
                    {mensaje}
                  </div>
                </CardHeader>
                <CardBody className="px-lg-3 py-lg-3 pt-0">
                  <Form role="form">
                    <FormGroup>
                      <InputGroup className="input-group-alternative">
                        <div className="inputs-icons-borderbott">
                          <Input
                            placeholder="Nueva contraseña"
                            type="password"
                            autoComplete="new-password"
                            onChange={tipContra}
                            name="contra"
                            value={contraProv}
                            style={{
                              fontSize: "14px",
                              border: "none",
                              width: "250px",
                              height: "25px",
                              padding: "0px 0px 0px 5px",
                              margin: "0px 0px 0px 0px",
                            }}
                          />
                          <img style={{ height: "16px" }} src={IconPasw}></img>
                        </div>
                      </InputGroup>
                      <PasswordStrengthBar
                        password={contraProv}
                        scoreWords={[
                          "Débil",
                          "Débil",
                          "Aceptable",
                          "Buena",
                          "Fuerte",
                        ]}
                        shortScoreWord={""}
                        minLength={10}
                        scoreWordStyle={{ "font-weight": "bold" }}
                        style={{ height: "5px" }}
                      />
                    </FormGroup>
                    <div className="text-center">
                      <Botonlogin indicador={3}></Botonlogin>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
            <Alerts data={listAlert}></Alerts>
          </div>
        </div>
      </Fragment>
    );
  } else if (inicio) {
    return <Redirect to="/admin/products" />;
  } else if (otptime) {
    return (
      <div>
        <Alerts data={listAlert}></Alerts>
      </div>
    );
  }
};

export default Cambio;
